import { useTranslation } from 'react-i18next';
import { Logo, useTheme, BHSLogoSmall } from '@ui';

export const BHSLogo = () => {
  const { t } = useTranslation();
  const { bgColorSecondary } = useTheme();

  return (
    <div className="flex items-center gap-0 md:gap-14">
      <div className="flex gap-2 items-end">
        <BHSLogoSmall className="w-[93px] h-[42px]" />
        <div className="flex gap-1 ml-[-49px] items-end">
          <div className="text-black text-[10px] leading-none">{t('common.powered_by')}:</div>
          <Logo className={'h-5 block w-auto text-black'} />
          <span
            className="text-[8px] leading-none text-base-100 rounded-lg px-1 py-[1px] w-fit"
            style={{ backgroundColor: bgColorSecondary }}
          >
            {t('common.beta')}
          </span>
        </div>
      </div>
    </div>
  );
};
